import React from 'react';

// Text input, two treatments:
//  - variant="box" (default) — 40px tall desktop / 48px mobile, 1px
//    rgb(216,216,216) border, 10px radius, white, 20px side padding, 600 14px
//    text. The placeholder is full-opacity ink. Used on the admin forms.
//  - variant="line" — borderless with only a bottom rule that darkens on focus,
//    ~17px vertical padding, 15px text, grey placeholder. The auth forms
//    (Login / Create Account / Reset Password).
type Variant = 'box' | 'line';

const VARIANTS: Record<Variant, string> = {
    box: 'h-12 rounded-btn border border-placeholder bg-surface px-5 text-ui font-semibold text-ink placeholder:text-ink placeholder:opacity-100 focus:border-ink-secondary md:h-10',
    line: 'border-b border-placeholder bg-transparent py-[17px] text-[15px] text-ink-secondary placeholder:text-[#B5B5B5] focus:border-ink-secondary',
};

type Props = React.InputHTMLAttributes<HTMLInputElement> & { variant?: Variant };

export const Input = React.forwardRef<HTMLInputElement, Props>(
    ({ className = '', variant = 'box', ...rest }, ref) => (
        <input
            ref={ref}
            className={`w-full outline-none focus:outline-none ${VARIANTS[variant]} ${className}`}
            {...rest}
        />
    ),
);

Input.displayName = 'Input';

export default Input;
